import { useState, useContext, useEffect, useRef } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser, BtnLoader } from "../../../components/widget"
import { ContextNav, ContextOverTime, ContextLoading, ContextDashboard } from "../../../context";
import { OverTimeApi, OverTimeChangeStatusApi, OverTimeExport } from "../../../api";
import { DatePicker } from "jalali-react-datepicker";
import { convertDateToString, converDurationToMin } from "../../../utils";
import { useSearchParams } from "react-router-dom";


export const OverTime = () => {
    const [searchParams] = useSearchParams();
    const formReason: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxOver = useContext(ContextOverTime)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [selectedDenay, setSelectedDenay] = useState<number>(0)
    const [withReason, setWithReason] = useState<number>(0)
    const [visibleReason, setVisibleReason] = useState<boolean>(false)
    const [visibleUser, setVisibleUser] = useState<boolean>(false)
    const [total, setTotal] = useState<any>(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [tableData, setTableData] = useState<any>([])
    const col: any = [
        {
            title: "کارمند ",
            render: (i: any) => (
                <div className="flex items-center h-[70px]">
                    <svg x="0px" y="0px" viewBox="0 0 512 512" className={`  w-[40px] fill-dayan-orange-50 `}>
                        <use xlinkHref="/assetes/svg/person.svg#person" />
                    </svg>
                    <span className="mr-2">{i.user && i.user != null && i.user.name}</span>
                </div>)
        },
        {
            title: "تاریخ ",
            render: (i: any) => (<>{i.created_at && i.created_at != null && new Date(i.created_at).toLocaleDateString('fa-Ir')}</>)
        },
        {
            title: "اضافه کاری",
            render: (i: any) => (<>
                {i.duration && i.duration != null &&
                    <div className="flex items-center">
                        {i.period == 'before' ?
                            <img src='/assetes/svg/sun.svg' className="w-3" />
                            :
                            <img src='/assetes/svg/moon.svg' className="w-3" />
                        }
                        <span className="mr-2"> {converDurationToMin(i.duration)}</span>
                    </div>
                }
            </>)
        },
        {
            title: "توضیحات ",
            render: (i: any) => (<>{i.description && i.description != null && i.description}</>)
        },
        {
            title: "وضعیت ",
            render: (i: any) => (<>
                {i.status && i.status != null && i.status == 0 && "بررسی نشده"}
                {i.status && i.status != null && i.status == 1 && "تایید شده"}
                {i.status && i.status != null && i.status == 2 && "رد شده"}
            </>)
        },
        {
            title: "علت رد شدن ",
            render: (i: any) => (<>{i.employer_reason && i.employer_reason != null && i.employer_reason}</>)
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex h-[45px] items-center w-full justify-around ">
                    <div onClick={() => changeStatusToAccespt(i.id, i.status, 1)} className="flex flex-col justify-center items-center cursor-pointer">
                        <svg x="0px" y="0px" viewBox="0 0 58 58" className={`  h-5 ${i.status == 1 ? 'fill-green-500' : 'fill-gray-300 '} `}>
                            <use xlinkHref="/assetes/svg/like.svg#like" />
                        </svg>
                        <span className="text-[11px] mt-1">تایید</span>
                    </div>
                    <div onClick={() => handelDenay(i.id, i.status, 2)} className="flex flex-col justify-center items-center cursor-pointer">
                        <svg x="0px" y="0px" viewBox="0 0 58 58" className={`  h-5 scale-y-[-1] ${i.status == 2 ? 'fill-red-500' : 'fill-gray-300 '} `}>
                            <use xlinkHref="/assetes/svg/like.svg#like" />
                        </svg>
                        <span className="text-[11px] mt-1">رد</span>
                    </div>
                </div>)
        },
    ]

    const exportFile = async (type: string) => {
        const res: any = await OverTimeExport(CtxOver.jsonParmsOverTime, type)
        var el = document.createElement("a");
        el.setAttribute("href", res);
        el.setAttribute("download", type == 'csv' ? 'export.csv' : 'export');
        el.setAttribute("target", '_blank');
        document.body.appendChild(el);
        el.click();
        el.remove();
    }

    const changePage = (type: string) => {
        let data = { ...CtxOver.jsonParmsOverTime };
        if (type == 'next') {
            data['page'] = currentPage + 1;
        }
        else {
            data['page'] = currentPage - 1;
        }
        CtxOver.setJsonParmsOverTime(data)
        getData(data)
    }


    const changeStatusToAccespt = async (id: any, currentStatus: any, newStatus: any) => {
        if (currentStatus == newStatus) return
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await OverTimeChangeStatusApi(id, newStatus, withReason, formReason)
        if (res.success) {
            getData(CtxOver.jsonParmsOverTime)
            CtxLoad.setDisplayLoadingBlur(false)
            toast("تغییر وضعیت صورت گرفت", { type: "success" })
        }
        else {
            CtxLoad.setDisplayLoadingBlur(false)
            toast(res.message, { type: "error" })
        }
    }

    const handelDenay = (id: any, currentStatus: any, newStatus: any) => {
        if (currentStatus == newStatus) return
        setSelectedDenay(id)
        setVisibleReason(true)
    }

    const onFinishDenay = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await OverTimeChangeStatusApi(selectedDenay, 2, withReason, formReason)
        if (res.success) {
            getData(CtxOver.jsonParmsOverTime)
            CtxLoad.setDisplayLoadingBtn(false)
            setVisibleReason(false)
            toast("تغییر وضعیت صورت گرفت", { type: "success" })
        }
        else {
            setVisibleReason(false)
            CtxLoad.setDisplayLoadingBtn(false)
            toast(res.message, { type: "error" })
        }
    }

    const handelSelectUsers = (userId: any) => {
        let data = { ...CtxOver.jsonParmsOverTime };
        if (data['user']) {
            if (data['user'].indexOf(userId) == -1) {
                data['user'].push(userId)
            }
            else {
                data['user'].splice(data['user'].indexOf(userId), 1)
            }
        }
        else {
            data['user'] = [userId];
        }
        CtxOver.setJsonParmsOverTime(data)
    }

    const handelFilterUser = () => {
        setVisibleUser(false)
        getData(CtxOver.jsonParmsOverTime)
    }

    const handelSelect = (e: any, name: any) => {
        let data = { ...CtxOver.jsonParmsOverTime };
        let active = { ...CtxOver.activeFilterOverTime };
        if (e.target.value != 'all') {
            data[name] = e.target.value;
            active[name] = e.target.value;
        }
        else {
            delete data[name];
            active[name] = -1;
        }
        CtxOver.setJsonParmsOverTime(data)
        CtxOver.setActiveFilterOverTime(active)
        getData(data)
    }

    const handelSearchQuery = (value: any, name: any) => {
        let data: any = { 'page': 1, 'user': [] };
        let active = { ...CtxOver.activeFilterOverTime };
        data[name] = value;
        active[name] = value;
        CtxOver.setJsonParmsOverTime(data)
        CtxOver.setActiveFilterOverTime(active)
        getData(data)
    }

    const handelSelectCustomTime = (e: any, type: string) => {
        let data = { ...CtxOver.jsonParmsOverTime };
        let active = { ...CtxOver.activeFilterOverTime };
        if (type == 'from') {
            data['from'] = e.value._i.slice(0, 10);
            active['startCalender'] = convertDateToString(e.value._i.slice(0, 10));
        }
        else if (type == 'to') {
            data['to'] = e.value._i.slice(0, 10);
            active['endCalender'] = convertDateToString(e.value._i.slice(0, 10));
        }
        CtxOver.setJsonParmsOverTime(data)
        CtxOver.setActiveFilterOverTime(active)
        getData(data)
    }

    const handelSelectPeriod = (value: any) => {
        let data = { ...CtxOver.jsonParmsOverTime };
        let active = { ...CtxOver.activeFilterOverTime };
        data['from'] = value[0].from;
        data['to'] = value[0].to;
        active['activePeriod'] = value[1]
        CtxOver.setJsonParmsOverTime(data)
        CtxOver.setActiveFilterOverTime(active)
        getData(data)
    }

    const getData = async (parms: any) => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await OverTimeApi(parms)
            setTableData(res.data.overtimes.data)
            setTotal(res.data.totals)
            CtxLoad.setDisplayLoadingSkelton(false)
            setCurrentPage(res.data.overtimes.current_page)
            setLastPage(res.data.overtimes.last_page)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "اضافه کاری | دایان"
        CtxNav.setActiveMenuItem({ 'item': 1, 'subItem': 2, })
        if (searchParams.get('status') != null) {
            handelSearchQuery(searchParams.get('status'), 'status')
        }
        else {
            getData(CtxOver.jsonParmsOverTime)
        }
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">اضافه‌کاری‌های پرسنل</h1>

            <div className=" w-full flex flex-wrap items-center">
                <div className="  w-full md:w-6/12 flex flex-wrap sm:flex-nowrap items-center pl-0 md:pl-2 justify-between">
                    <div onClick={() => { setVisibleUser(true) }} className="w-[49%]  h-[40px] sm:h-[50px] bg-white rounded-md shadow px-[15px] sm:text-[13px] text-[11px] flex items-center  cursor-pointer">
                        <span>{CtxOver.jsonParmsOverTime?.user.length == 0 && 'انتخاب کارمند'}</span>
                        <span>{CtxOver.jsonParmsOverTime?.user.length > 0 && `${CtxOver.jsonParmsOverTime?.user.length} کارمند انتخاب شد`}</span>
                    </div>
                    <div className=" w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow text-sm">
                        <CSelect defaultValue={CtxOver.activeFilterOverTime.qr_code_id != -1 ? CtxOver.activeFilterOverTime.qr_code_id : ""} placeholder={'موقعیت مکانی'} onChange={(e: any) => handelSelect(e, 'qr_code_id')} >
                            <option value={'all'}>همه</option>
                            {CtxDash.location?.map((item: any, index: number) =>
                                <option value={item.id}>{item.name}</option>
                            )}
                        </CSelect>
                    </div>
                </div>
                <div className=" w-full md:w-6/12 mt-2 md:mt-0 flex items-center justify-between">
                    <div className=" w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow text-sm">
                        <CSelect defaultValue={CtxOver.activeFilterOverTime.type != -1 ? CtxOver.activeFilterOverTime.type : ""} placeholder={'نوع اضافه کاری'} onChange={(e: any) => handelSelect(e, 'type')} >
                            <option value={'all'}>همه</option>
                            <option value={1}>قبل از شیف</option>
                            <option value={2}>بعد از شیف</option>
                        </CSelect>
                    </div>
                    <div className=" w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow text-sm">
                        <CSelect defaultValue={CtxOver.activeFilterOverTime.status != -1 ? CtxOver.activeFilterOverTime.status : ""} placeholder={'وضعیت'} onChange={(e: any) => handelSelect(e, 'status')} >
                            <option value={'all'}>همه</option>
                            <option value={0}>بررسی نشده</option>
                            <option value={1}>موجه</option>
                            <option value={2}>غیر موجه</option>
                        </CSelect>
                    </div>
                </div>
            </div>

            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <div className="w-full md:w-fit flex items-center">
                    <div className="   hidden md:flex items-center pl-2">
                        <div onClick={() => exportFile('csv')} className=" w-[60px] h-[60px] bg-dayan-gray-200 rounded-md flex justify-center items-center cursor-pointer">
                            <svg x="0px" y="0px" viewBox="0 0 548.29 548.291" className={`  h-7 fill-white `}>
                                <use xlinkHref="/assetes/svg/csv.svg#csv" />
                            </svg>
                        </div>
                        <div onClick={() => exportFile('excel')} className=" w-[60px] h-[60px] bg-dayan-gray-200 rounded-md flex justify-center items-center cursor-pointer mr-2">
                            <svg x="0px" y="0px" viewBox="0 0 26 26" className={`  h-7 fill-green-800 `}>
                                <use xlinkHref="/assetes/svg/excel.svg#excel" />
                            </svg>
                        </div>
                    </div>
                    <div className=" w-full md:w-[200px] flex flex-col">
                        <ReportSelectPeriod onChange={(value: any) => handelSelectPeriod(value)} activeTab={CtxOver.activeFilterOverTime.activePeriod} />
                        <div className=" w-full flex   mt-2">
                            <div className="jalali-datePicker w-full h-[30px] ml-1 bg-white rounded-lg shadow flex justify-center items-center text-[11px] relative group">
                                <div className="bg-dayan-gray-200 w-fit h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">تاریخ شروع</div>
                                <DatePicker timePicker={false} value={CtxOver.activeFilterOverTime?.startCalender} onClickSubmitButton={(e: any) => { handelSelectCustomTime(e, 'from') }} />
                            </div>
                            <div className="jalali-datePicker w-full h-[30px] mr-1 bg-white rounded-lg shadow flex justify-center items-center text-[11px] relative group">
                                <div className="bg-dayan-gray-200 w-fit h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">تاریخ پایان</div>
                                <DatePicker timePicker={false} value={CtxOver.activeFilterOverTime?.endCalender} onClickSubmitButton={(e: any) => { handelSelectCustomTime(e, 'to') }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                    <button onClick={() => exportFile('csv')} className="w-full md:w-[120px] h-[30px] md:h-[40px] md:hidden flex bg-dayan-gray-200 rounded-md text-sm text-white justify-center items-center text-center text-[11px]">CSV</button>
                    <button onClick={() => exportFile('excel')} className="w-full md:w-[120px] h-[30px] md:h-[40px] mx-1 md:hidden flex bg-dayan-gray-200 rounded-md text-sm text-white justify-center items-center text-center text-[11px]">اکسل</button>
                </div>
            </div>

            <div className=" w-full mt-[20px]">
                {CtxLoad.displayLoadingSkelton == false ?
                    <TablePage columns={col} data={tableData} >
                        <TablePagination currentPage={currentPage} lastPage={lastPage} onChange={changePage} />
                    </TablePage>
                    :
                    <CSkeletonTable />
                }
            </div>

            {total != null && tableData?.length > 0 &&
                <div className=" w-full my-[40px] px-3 flex flex-col rounded-lg overflow-hidden table-report-shadow bg-[#f8f8f8]">
                    <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end border-b text-[12px]">
                        مجموع کل اضافه‌کاری‌ها :  {converDurationToMin(total.all)}
                    </div>
                    <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end border-b text-[12px]">
                        مجموع اضافه‌کاری‌های بررسی‌نشده : {converDurationToMin(total.pending)}
                    </div>
                    <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end border-b text-[12px]">
                        مجموع اضافه‌کاری‌های تایید‌شده :  {converDurationToMin(total.approved)}
                    </div>
                    <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end text-[12px]">
                        مجموع اضافه‌کاری‌های ردشده :  {converDurationToMin(total.rejected)}
                    </div>
                </div>
            }

            <ModalFilterUser visible={visibleUser} setVisible={setVisibleUser} onOk={handelFilterUser} listUser={CtxDash.employees} listSelected={CtxOver.jsonParmsOverTime?.user} selectUser={handelSelectUsers} />

            <CModal visible={visibleReason} setVisible={setVisibleReason} radius={'10px'} uId="Mo-reason">
                <form onSubmit={onFinishDenay} ref={formReason} className="w-full  flex flex-col p-[10px] ">
                    <label onClick={() => { setWithReason(0) }} className=" flex items-center mt-2 cursor-pointer">
                        <input type={'radio'} name="reason" value={0} checked={withReason == 0 ? true : false} />
                        <span className="mr-2">بدون ذکر دلیل</span>
                    </label>
                    <label onClick={() => { setWithReason(1) }} className=" flex items-center mt-2 cursor-pointer">
                        <input type={'radio'} name="reason" value={1} checked={withReason == 1 ? true : false} />
                        <span className="mr-2">با ذکر دلیل</span>
                    </label>
                    <span className="text-[11px] mr-2 mt-2 mb-1">علت رد شدن به پرسنل نمایش داده خواهد شد</span>
                    <textarea name="employer_reason" className="mb-2 p-2 h-[140px] border rounded-md focus:outline-none" required={withReason == 1 ? true : false} />
                    <div className=" flex items-center my-2">
                        {CtxLoad.displayLoadingBtn ?
                            <button type={'button'} className=" w-[80px] mx-2 h-10 bg-dayan-orange-50  flex items-center justify-center rounded-[5px] text-white relative">
                                <BtnLoader />
                            </button>
                            :
                            <button type={'submit'} className=" w-[80px] mx-2 h-10 bg-dayan-orange-50  flex items-center justify-center rounded-[5px] text-white">
                                <span>اعمال</span>
                            </button>
                        }
                        <button type={'button'} onClick={() => { setVisibleReason(false) }} className=" w-[80px] mx-2 h-10 bg-dayan-gray-100  flex items-center justify-center rounded-[5px] text-white">
                            <span>لغو</span>
                        </button>
                    </div>
                </form>
            </CModal>

        </div>
    )
}
